let dropdownSP = document.getElementById("dropdownSP");
let dropdownSlide = document.getElementById("dropdownSlide");

window.onload = function () {
  dropdownSP.onclick = function () {
    dropdownSlide.classList.toggle("slide-open");
    if (document.getElementById("dropdownTrigger").innerText === "+") {
      document.getElementById("dropdownTrigger").innerText = "ㅡ";
    } else {
      document.getElementById("dropdownTrigger").innerText = "+";
    }
  };
};
